module.exports = __webpack_public_path__ + "static/media/NightStand_After.c28cdbbe.jpg";